(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dj-delivery-fee-assets"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.djDeliveryFees) return;
  const configElement = document.getElementById('dj-delivery-fee-config');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const rawFetch = window.fetch.bind(window);
  const root = window.Shopify?.routes?.root || '/';
  let tail = Promise.resolve();
  let lastCart;
  let pending = 0;
  let failure = '';
  const pendingChoices = {};
  const nativeFee = (item, fee) => fee.variantId && String(item.variant_id) === String(fee.variantId);
  const feeFor = item => config.fees.find(fee => nativeFee(item, fee)
    || String(item.variant_id) === fee.legacyVariantId
    || String(item.variant_id) === fee.previousVariantId
    || (String(item.variant_id) === '67007337529715' && item.properties?._chargefee_parent_fee_public_id === fee.publicId));
  const merchandiseCount = cart => cart.items.filter(item => !feeFor(item)).reduce((sum, item) => sum + item.quantity, 0);
  const amount = fee => Number(fee.amount);
  const selected = (cart, fee) => cart.attributes?.[fee.attribute] === undefined
    ? cart.items.some(item => feeFor(item)?.key === fee.key)
    : cart.attributes[fee.attribute] === '1';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency: lastCart?.currency || config.currency
  }).format(cents / 100);

  function paint() {
    document.documentElement.classList.toggle('dj-fees-busy', pending > 0);
    document.documentElement.classList.toggle('dj-has-delivery-fees', Boolean(lastCart?.items.some(feeFor)));
    document.querySelectorAll('cart-items input:not([type="hidden"]), cart-items button').forEach(control => {
      if (pending > 0 && control.dataset.djWasDisabled === undefined) {
        control.dataset.djWasDisabled = String(control.disabled);
        control.disabled = true;
      } else if (!pending && control.dataset.djWasDisabled !== undefined) {
        control.disabled = control.dataset.djWasDisabled === 'true';
        delete control.dataset.djWasDisabled;
      }
    });
    document.querySelectorAll('[data-dj-fees]').forEach(panel => {
      const hasItems = !lastCart || merchandiseCount(lastCart) > 0;
      panel.hidden = !hasItems;
      panel.setAttribute('aria-busy', String(pending > 0));
      panel.querySelectorAll('[data-dj-fee]').forEach(input => {
        const fee = config.fees.find(entry => entry.key === input.dataset.djFee);
        input.disabled = pending > 0 || !fee.variantId;
        if (lastCart) input.checked = pendingChoices[fee.key] ?? selected(lastCart, fee);
        const card = input.closest('.dj-fee-option');
        card.classList.toggle('is-selected', input.checked);
        if (lastCart) card.querySelector('[data-dj-fee-price]').textContent = money(amount(fee));
      });
      const status = panel.querySelector('[data-dj-fee-status]');
      status.textContent = failure || (pending > 0 ? config.messages.updating : '');
      status.classList.toggle('is-error', Boolean(failure));
    });
  }

  function queue(work) {
    pending += 1;
    paint();
    const result = tail.then(work);
    tail = result.catch(() => undefined);
    return result.then(value => { failure = ''; return value; }, error => {
      failure = config.messages.error;
      console.error('[Freight services]', error);
      throw error;
    }).finally(() => { pending -= 1; paint(); });
  }

  async function request(endpoint, body) {
    const response = await rawFetch(root + endpoint, body ? {
      method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify(body)
    } : {headers: {Accept: 'application/json'}, cache: 'no-store'});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || `Cart request failed (${response.status})`);
    return data;
  }

  async function synchronize(overrides = {}) {
    let cart = await request('cart.js');
    lastCart = cart;
    let changed = false;
    const wanted = Object.fromEntries(config.fees.map(fee => [fee.key,
      merchandiseCount(cart) > 0 && (overrides[fee.key] ?? selected(cart, fee))]));
    const updates = {}, attributes = {};
    for (const fee of config.fees) {
      if (wanted[fee.key] && (!fee.variantId || amount(fee) <= 0)) throw new Error(`Unavailable service: ${fee.key}`);
      let retained = false;
      for (const line of cart.items.filter(item => feeFor(item)?.key === fee.key)) {
        const legacyProperties = Object.keys(line.properties || {}).some(key => key.startsWith('_chargefee_'));
        if (!wanted[fee.key] || !nativeFee(line, fee) || legacyProperties || retained) {
          updates[line.key] = 0;
        } else {
          retained = true;
          if (line.quantity !== 1) updates[line.key] = 1;
        }
      }
      const value = wanted[fee.key] ? '1' : '0';
      if (cart.attributes?.[fee.attribute] !== value) attributes[fee.attribute] = value;
    }
    if (Object.keys(updates).length || Object.keys(attributes).length) {
      await request('cart/update.js', {updates, attributes});
      cart = await request('cart.js');
      lastCart = cart;
      changed = true;
    }
    const additions = config.fees.filter(fee => wanted[fee.key] && !cart.items.some(item => nativeFee(item, fee)))
      .map(fee => ({id: fee.variantId, quantity: 1, properties: {_dj_delivery_fee: fee.key, _dj_delivery_fee_version: '2'}}));
    if (additions.length) {
      await request('cart/add.js', {items: additions});
      cart = await request('cart.js');
      changed = true;
    }
    lastCart = cart;
    for (const fee of config.fees) {
      const lines = cart.items.filter(item => feeFor(item)?.key === fee.key);
      if (wanted[fee.key]) {
        if (lines.length !== 1 || !nativeFee(lines[0], fee) || lines[0].quantity !== 1) {
          throw new Error(`Service quantity could not be verified: ${fee.key}`);
        }
        const basePrice = lines[0].original_line_price ?? lines[0].price;
        if (Number(basePrice) !== amount(fee)) throw new Error(`Service price could not be verified: ${fee.key}`);
      } else if (lines.length) {
        throw new Error(`Service removal could not be verified: ${fee.key}`);
      }
    }
    return {cart, changed};
  }

  async function sectionsFor(ids) {
    if (!ids.length) return {};
    const url = new URL(window.location.href);
    url.searchParams.set('sections', [...new Set(ids)].join(','));
    const response = await rawFetch(url, {cache: 'no-store'});
    if (!response.ok) throw new Error(config.messages.error);
    return response.json();
  }

  async function render() {
    const main = document.querySelector('.cc-main-cart');
    const drawer = document.querySelector('cart-drawer');
    const mainId = main?.id.replace('shopify-section-', '');
    const drawerId = drawer?.closest('.shopify-section')?.id.replace('shopify-section-', '');
    const sections = await sectionsFor([mainId, drawerId, 'cart-icon-bubble'].filter(Boolean));
    const focusedFee = document.activeElement?.dataset?.djFee;
    const drawerScroll = drawer?.querySelector('.drawer__content')?.scrollTop;
    if (main && sections[mainId]) {
      const html = new DOMParser().parseFromString(sections[mainId], 'text/html');
      const replacement = html.querySelector('.cc-main-cart');
      if (replacement) main.innerHTML = replacement.innerHTML;
    }
    if (drawer && sections[drawerId]) {
      await drawer.renderContents({sections}, false);
      drawer.cartSummary = drawer.querySelector('.cart-drawer__summary');
      const content = drawer.querySelector('.drawer__content');
      if (content) content.scrollTop = drawerScroll || 0;
    } else if (sections['cart-icon-bubble']) {
      const html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble) bubble.innerHTML = html.querySelector('.shopify-section')?.innerHTML || '';
    }
    paint();
    if (focusedFee) document.querySelector(`[data-dj-fee="${focusedFee}"]`)?.focus();
    document.dispatchEvent(new CustomEvent('on:css-var-height:update'));
  }

  async function getPayload(input, init) {
    let body = init?.body;
    if (!body && input instanceof Request) body = await input.clone().text();
    if (typeof body === 'string') { try { return JSON.parse(body); } catch { return Object.fromEntries(new URLSearchParams(body)); } }
    if (body instanceof FormData || body instanceof URLSearchParams) return Object.fromEntries(body);
    return {};
  }

  window.fetch = function(input, init) {
    const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, window.location.href);
    const method = (init?.method || (input instanceof Request ? input.method : 'GET')).toUpperCase();
    if (url.origin !== window.location.origin || method !== 'POST' || !/\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname)) return rawFetch(input, init);
    let originalResponse;
    return queue(async () => {
      const submitted = await getPayload(input, init);
      const response = await rawFetch(input, init);
      originalResponse = response;
      if (!response.ok) return response;
      const payload = await response.clone().json();
      const result = await synchronize();
      const ids = Array.isArray(submitted.sections) ? submitted.sections : String(submitted.sections || '').split(',').filter(Boolean);
      if (ids.length) payload.sections = await sectionsFor(ids);
      else if (result.changed) await render();
      if (!/\/cart\/add/.test(url.pathname)) Object.assign(payload, result.cart);
      return new Response(JSON.stringify(payload), {status: response.status, headers: {'Content-Type': 'application/json'}});
    }).catch(error => {
      if (originalResponse?.ok) return originalResponse;
      throw error;
    });
  };

  document.addEventListener('change', event => {
    const input = event.target.closest('[data-dj-fee]');
    if (!input) return;
    const key = input.dataset.djFee;
    const checked = input.checked;
    pendingChoices[key] = checked;
    queue(async () => { await synchronize({[key]: checked}); await render(); }).catch(() => undefined).finally(() => { delete pendingChoices[key]; paint(); });
  });

  async function checkout(event) {
    if (event.type === 'submit' && !event.target.matches('#cart, #cart-drawer-form')) return;
    if (event.type === 'submit' && !event.submitter?.matches('[name="checkout"]')) return;
    const trigger = event.type === 'submit' ? event.submitter : event.target.closest('[name="checkout"], a[href*="/checkout"]');
    if (!trigger || trigger.closest('.shopify-payment-button')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    queue(async () => {
      const {cart} = await synchronize();
      if (!merchandiseCount(cart)) { await render(); return; }
      window.location.assign(root + 'checkout');
    }).catch(() => undefined);
  }
  document.addEventListener('click', checkout, true);
  document.addEventListener('submit', checkout, true);
  document.addEventListener('click', event => {
    if (pending && event.target.closest('cart-items .js-remove-item')) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('on:cart:after-merge', paint);
  document.addEventListener('on:cart:after-add', paint);
  new MutationObserver(() => {
    if (document.querySelector('[data-dj-fees]:not([data-dj-ready])')) {
      document.querySelectorAll('[data-dj-fees]').forEach(panel => { panel.dataset.djReady = 'true'; });
      paint();
    }
  }).observe(document.body, {childList: true, subtree: true});
  const refresh = () => queue(async () => { const result = await synchronize(); if (result.changed) await render(); }).catch(() => undefined);
  window.addEventListener('pageshow', event => { if (event.persisted) refresh(); });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') refresh(); });
  window.djDeliveryFees = {refresh};
  refresh();
})();
  } catch(e) { console.error(e); }
})();

})();
